import { useToastContext } from "components/alert/ToastContext";
import BaseListagem from "components/BaseListagem";
import ModalColetaIndicador from "components/modal/indicadores/ModalColetaIndicador";
import Usuario from "model/administracao/cadastro/Usuario";
import Processo from "model/indicadores/Processo";
import UnidadeOrganizacional from "model/indicadores/UnidadeOrganizacional";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { SplitButton } from "primereact/splitbutton";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import IndicadorService from "service/indicadores/IndicadorService";
import { dropdownFilterTemplate, filterApplyTemplate, IdMatchModeOptions, TextMatchModeOptions } from "utils/filterUtils";
import saveAs from 'file-saver';
import { Dialog } from "primereact/dialog";
import ReportEdit from "components/reports/ReportEdit";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";

const indicadorService = new IndicadorService();
const usuarioLogadoService = new UsuarioLogadoService();

export default function IndicadorListagem() {

    const [titulo, setTitulo] = useState<string>('Indicadores');
    const navigate = useNavigate();
    const [modalColeta, setModalColeta] = useState<{ visible: boolean, indicadorId: number }>({ visible: false, indicadorId: 0 });

    const [editaRelatorioApresentacao, setEditaRelatorioApresentacao] = useState<boolean>(false);
    const [visibleDialogRelatorios, setVisibleDialogRelatorios] = useState<boolean>(false);

    const [processos, setProcessos] = useState<Processo[]>([]);
    const [unidades, setUnidades] = useState<UnidadeOrganizacional[]>([]);
    const [usuarios, setUsuarios] = useState<Usuario[]>([]);

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();
    const { startLoading, stopLoading } = useLoadingContext();

    useEffect(() => {
        usuarioLogadoService.getAcoesUsuarioLogado().then((resposta) => {
            if (usuarioLogadoService.usuarioTemAcao(resposta, "RELATORIO_INDICADOR_APRESENTACAO")) {
                setEditaRelatorioApresentacao(true);
            }
        }).catch((erro) => {
            console.log(erro);
        });
        indicadorService.processos().then((response) => {
            setProcessos(response);
        }).catch((error) => {
            console.error("Erro ao buscar processos:", error);
        });

        indicadorService.unidadesOrgan().then((response) => {
            setUnidades(response);
        }).catch((error) => {
            console.error("Erro ao buscar unidades organizacionais:", error);
        });
        indicadorService.usuarios().then((response) => {
            setUsuarios(response);
        }).catch((error) => {
            console.error("Erro ao buscar usuários:", error);
        });
    }, [])

    const defaultFilters: DataTableFilterMeta = {
        codigo: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        nome: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        processo: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        unidadeOrganizacional: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        usuarioColeta: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        }
    }

    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);

    function getButtonsExtra() {
        return (
            [editaRelatorioApresentacao ? <SplitButton
                style={{ marginRight: 8 }}
                icon="pi pi-file-pdf"
                onClick={() => gerarRelatorioApresentacao()}
                model={[{
                    label: "Alterar relatórios",
                    command: () => setVisibleDialogRelatorios(true)
                }]}
            /> : <Button
                style={{ marginRight: 8 }}
                type="button"
                icon="pi pi-file-pdf"
                onClick={() => gerarRelatorioApresentacao()}
            />]
        )
    }

    function gerarRelatorioApresentacao() {
        startLoading();
        indicadorService.getRelatorioApresentacao(filters).then(data => {
            stopLoading();
            const file = new Blob([data], { type: 'application/pdf' });
            saveAs(file, `Apresentação Indicadores.pdf`);
        }).catch(err => {
            stopLoading();
            msgErro("Erro ao gerar Relatório", err.message);
            console.log(err);
        });
    }

    return (
        <>
            {modalColeta.visible && <ModalColetaIndicador visible={modalColeta.visible}
                onHide={() => {
                    setModalColeta({ visible: false, indicadorId: 0 });
                }}
                indicadorId={modalColeta.indicadorId}
            />}

            <Dialog visible={visibleDialogRelatorios}
                onHide={() => setVisibleDialogRelatorios(false)}
                header="Editar relatório"
                style={{ width: "50%" }}
            >
                <ReportEdit nomeAcao="RELATORIO_INDICADOR_APRESENTACAO" titulo="Relatório de apresentação" testarRelatorio={() => { }} style={{ marginBottom: 10 }} />
            </Dialog>

            <BaseListagem
                buttonsExtra={getButtonsExtra()}
                ordenacao={"nome,ASC"}
                service={indicadorService}
                onChangeFilters={setFilters}
                urlService={"/indicador"}
                tituloPagina={titulo}
                nome="indicador"
                defaultFilters={defaultFilters}
                showClearFilterButton
            >
                <Column field="codigo" header="Código" filterField="codigo" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
                <Column field="nome" header="Nome" filterField="nome" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
                <Column field="processo.nome" header="Processo" filter filterField="processo" showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => dropdownFilterTemplate(options, processos)} />
                <Column field="unidadeOrganizacional.nome" header="Unid. Organ." filter filterField="unidadeOrganizacional" showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => dropdownFilterTemplate(options, unidades)} />
                <Column field="usuarioColeta.nome" header="Responsável" filter filterField="usuarioColeta" showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => dropdownFilterTemplate(options, usuarios)} />
                <Column body={(rowData) => {
                    return <Button icon="pi pi-eye" className="p-button-rounded p-button-info" onClick={() => {
                        navigate(`/indicador/dashboard/${rowData.id}`)
                    }} />
                }} />
            </BaseListagem>
        </>
    )
}